import React from 'react';
import { AwardIcon, LockIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { SectionHeading } from './ui/SectionHeading';
import { checkoutUrl, price, priceBefore, productShortName, totalBonuses, totalVolumes } from '../data/offer';
export function PricingSection() {
  return <section id="pricing" className="scroll-mt-4 bg-background py-16 sm:py-24" aria-labelledby="pricing-title" data-id="element-138" data-mp="1j9qpghfdfsh6">
      <div className="mx-auto max-w-3xl px-4" data-id="element-139" data-mp="1na0r5hw4rwq8">
        <SectionHeading id="pricing-title" data-id="element-140" data-mp="1s9dh4biatjx1">Choose Your Option</SectionHeading>

        <article className="mt-10 overflow-hidden rounded-3xl border-2 border-primary bg-surface shadow-[0_0_0_4px_rgb(var(--color-primary)/0.15),0_24px_60px_-20px_rgb(var(--color-accent)/0.45)]" data-id="element-141" data-mp="1sbgh9od60tfh">
          <div className="border-b border-primary/30 bg-soft px-6 py-4 sm:px-10" data-id="element-142" data-mp="225gqo2fhcku0">
            <span className="inline-flex items-center gap-2 rounded-full bg-gold px-3 py-1.5 text-[11px] font-extrabold uppercase tracking-[.14em] text-gold-foreground" data-id="element-143" data-mp="2wjsrxga0a7b">
              <AwardIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-144" data-mp="1mhgaynz6vbbo" /> Main Offer
            </span>
          </div>
          <div className="p-6 sm:p-10" data-id="element-145" data-mp="1hodgmdml7xuf">
            <div className="flex flex-col gap-6 sm:flex-row sm:items-end sm:justify-between" data-id="element-146" data-mp="1cqv4yfh6r4iq">
              <div data-id="element-147" data-mp="17rsa1nux6eoh">
                <h3 className="text-3xl font-bold leading-tight tracking-tight text-foreground" data-id="element-148" data-mp="17sacx3c37r5d">{productShortName}</h3>
                <p className="mt-2 text-sm text-muted" data-id="element-149" data-mp="25ehj2ho1hrju">
                  All {totalVolumes} volumes + {totalBonuses} exclusive bonuses
                </p>
              </div>
              <div className="shrink-0 sm:text-right" data-id="element-150" data-mp="1vgtlzl2yo7yi">
                <span className="text-sm text-muted" data-id="element-151" data-mp="1vfjnius74xrc">
                  Regular price: <span className="line-through decoration-accent decoration-2" data-id="element-152" data-mp="1req002io1kyz">{priceBefore}</span>
                </span>
                <p className="mt-2 text-xs font-bold uppercase tracking-[.14em] text-primary-strong" data-id="element-153" data-mp="k3ircut0671k">Today:</p>
                <p className="mt-1 whitespace-nowrap text-6xl font-extrabold leading-none tracking-tight text-foreground" data-id="element-154" data-mp="g2p5s83194bu">{price}</p>
              </div>
            </div>

            <Button href={checkoutUrl} target="_blank" rel="noopener noreferrer" arrow className="mt-9 w-full" data-id="element-155" data-mp="mfjmpx2a4ttz">
              Get my professional edition now
            </Button>

            <div className="mt-6 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-semibold text-muted" data-id="element-156" data-mp="chvogx5gt472">
              <span className="inline-flex items-center gap-1.5" data-id="element-157" data-mp="3uvw92u8zl38p">
                <LockIcon className="h-4 w-4 text-primary-strong" aria-hidden="true" data-id="element-158" data-mp="3iidu15lu9kr" /> Secure payment
              </span>
              <span className="inline-flex items-center gap-1.5" data-id="element-159" data-mp="3kzjhc1x04zgl">
                <ZapIcon className="h-4 w-4 text-primary-strong" aria-hidden="true" data-id="element-160" data-mp="3pxbjrpv9w3z1" /> Instant access
              </span>
              <span className="inline-flex items-center gap-1.5" data-id="element-161" data-mp="3bxjwszms3d8w">
                <ShieldCheckIcon className="h-4 w-4 text-primary-strong" aria-hidden="true" data-id="element-162" data-mp="3fzdvx3hbs96y" /> 7-day guarantee
              </span>
            </div>
          </div>
        </article>
      </div>
    </section>;
}